import './Theme.Tag.Rounded.scss';
export default 'ThemeTagRounded';
